import languageModel from "../../../models/language.model"

export default function CommonFooterComponent() {
  return {
    view: ({ attrs: {
      actionHandler = () => { },
      cancelHandler = () => { },
    } }) => {
      return m('.card-footer',
        m('.col-md-12.gap-2.d-flex.justify-content-end',
          m("button.btn.btn-primary[type='button']", { onclick: actionHandler }, languageModel.getText("LT00000022", "Save")),
          m("button.btn.btn-white[type='button']", { onclick: cancelHandler }, languageModel.getText("LT00000021", "Close"))
        )
      )
    }
  }
}